<template>
    <div>
        <h2 class="header">Уровень развития компетенций:</h2>
        <table>
            <th>Компетенция</th>
            <th>Оценка кандидата</th>
            <tr v-for="(item, key) in pools" :key="key">
                <td class="title">{{item.title}}</td>
                <td :class="isValid(item.result)" class="result">{{itemView(item.result)}}</td>
            </tr>
        </table>
    </div>


</template>

<script>
    export default {
        name: "LevelInfo",
        props: ['pools'],
        methods: {
            itemView(value) {
                if (value === 0) {
                    return null
                }
                return value
            },
            isValid(value) {
                let is_risk = false;
                let is_valid = false;
                if (value < this.$store.getters.Q_ONE.min_level) {
                    is_risk = true;
                }
                if (value === 0) {
                    is_risk = false;
                }
                if (value === null) {
                    is_risk = false;
                }
                if (value >= this.$store.getters.Q_ONE.min_level) {
                    is_valid = true;
                }
                if (value === '2НД') {
                    is_valid = false;
                }
                return {
                    risk: is_risk,
                    valid: is_valid
                }
            }
        }
    }
</script>

<style scoped>
    .header {
        text-align: left;
        margin-bottom: 0;
    }

    table {
        margin-top: 0;
        width: 100%;
    }

    table, th, td {
        border: 1px solid black;
        border-collapse: collapse;
    }

    th, td {
        width: 50%;
        padding: 5px;
        text-align: center;
    }
    .title {
        text-align: left;
    }
    .risk {
        background-color: red;
    }
    .valid {
        background-color: green;
    }
</style>